<template>
  <button class="g--button" @click="buyPackage()">Buy package</button>

  <Teleport to="body">
    <div ref="modal">
      <div
          v-if="showPaymentForm"
          id="payment-form-wrapper"
          class="fixed z-20 h-full w-full bg-black/80 top-0 left-0 flex justify-center items-center">

        <div ref="innerModal" class="bg-white rounded-md p-4 w-full max-w-[450px] min-h-[250px]">
          <div class="g--label">Package</div>

          <div class="mt-4">
            <div class="g--label">Email address</div>
            <div class="text-sm">{{ email }}</div>
            <div class="g--label mt-4">Terms & Conditions</div>
            <div class="flex mt-2">
              <input class="mr-2" type="checkbox" id="terms" v-model="acceptedTerms"/>
              <label for="terms" class="text-sm">I accept the terms & conditions</label>
            </div>
            <button :disabled="!acceptedTerms" class="g--button mt-4 w-full" @click="doStep2()">Next
            </button>
          </div>
          <div v-if="step == 2">
            <div class="g--label mt-4 mb-2">Payment</div>
            <div class="min-h-[205px] flex items-center justify-center">
              <div ref="spinner">
                <Spinner></Spinner>
              </div>
              <form id="payment-form"
                    class="hidden w-full ">
                <div id="payment-element">
                  <!-- Elements will create form elements here -->
                </div>
                <button class="g--button mt-4" id="submit">Pay</button>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import Spinner from './Spinner.vue';
import SessionRedux from './SessionRedux.vue';

const stripe = Stripe('pk_test_51Hf3whA9djpx0tsZwIc9BSTvenACfV7sAiZqinCvpSqZuliOJmO8tllMA3sFZeyHXT1kZFpGXLFS22A8CmxkKAsT00szimVi0m', {
  stripeAccount: 'acct_1QRhyOPRMnBUIJx4',
});

const props = defineProps({
  productId: {
    type: Number,
    required: true
  }
});


const showPaymentForm = ref(false);
const acceptedTerms = ref(false);
const step = ref(1);

const startCheckout = () => {
  // paymentFormWrapper.value.classList.remove('hidden');
  showPaymentForm.value = true;
  buyPackage();
}
const buyPackage = () => {
  let data = {};
  data[csrfTokenName] = csrfTokenValue;

  fetch('/actions/live-yoga-teachers/checkout/package-checkout?productId=' + props.productId, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(data),
  }).then((response) =>
      response.json().then((json) => {
        console.log(json);
      })
  );


}

</script>